import type { Entity } from '@thinkalpha/ui-types/types/admin/index';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const accessApi = createInstance({ baseURL: appConfig.accessApi });

export async function getEntitiesById(ids: Array<string>): Promise<Array<Entity>> {
    const { data } = await accessApi.get<Array<Entity>>(`/entities`, { params: { ids } });
    return data;
}
